module.exports = __webpack_public_path__ + "images/exterior-restyling-1-b87bc96ae1ca2ab0e5552e0d011335bf.jpg";